"use client";

import { useEffect, useRef } from "react";

import { trackEvent } from "@/utils/analytics";

/**
 * 스크롤 깊이 추적 (25/50/75/100%)
 * 각 깊이 도달 시 scroll_depth 이벤트 1회 발송
 */
export function useScrollDepthTracking() {
  const firedRef = useRef(new Set<number>());

  useEffect(() => {
    const thresholds = [25, 50, 75, 100];

    const handleScroll = () => {
      const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (scrollHeight <= 0) return;

      const percent = Math.round((window.scrollY / scrollHeight) * 100);

      for (const t of thresholds) {
        if (percent >= t && !firedRef.current.has(t)) {
          firedRef.current.add(t);
          trackEvent("scroll_depth", {
            depth_percent: t,
            page_location: window.location.pathname,
          });
        }
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
}
